import {
  AppBar,
  Box,
  Button,
  Dialog,
  DialogProps,
  Paper,
  TableContainer,
} from "@mui/material";
import React from "react";
import styles from "../../../styles/pages/home.module.scss";
import CloseIcon from "@mui/icons-material/Close";
// import Pagination from "../UtilitiesComponent/Pagination";
import GlobalDialogTransition from "../../UtilitiesComponent/GlobalDialogTransition";
import PerfectScrollbar from "react-perfect-scrollbar";
import "react-perfect-scrollbar/dist/css/styles.css";

// export type SimpleModalTableWrapperProps = DialogProps & {};

// type SimpleModalTableWrapperPropsPrivate = SimpleModalTableWrapperProps & {
//   children: React.ReactNode;
//   modalHeader?: React.ReactNode;
//   filterRow?: React.ReactNode;
// };

export default function DashboardModalWrapper({
  open,
  onClose,
  children,
  modalHeader,
  filterRow,
  ...rest
}) {
  return (
    <Dialog
      fullScreen
      open={open}
      onClose={onClose}
      TransitionComponent={GlobalDialogTransition}
      {...rest}
      className={styles.modal_close_opt}
    >
      <AppBar sx={{ position: "relative" }} className={styles.header_modal}>
        <Button
          color="inherit"
          onClick={(e) => onClose?.(e, "backdropClick")}
          className={styles.modal_cross_icon}
        >
          <CloseIcon />
        </Button>
      </AppBar>
      <Box className={`${styles.modal_main_body} ${styles.modal_mainwrp}`}>
        <Box className={`${styles.dashboard_confirm_sec} ${styles.dashboard_cofrmer_out}`}>{modalHeader}</Box>
        <Box className={styles.dashbrdContent_box}>
          <Box className="dashboardAllTable">
            {/* <PerfectScrollbar> */}
              <Box className={`${styles.table_sec} ${styles.table_sec_htt} ${styles.tableDashboardMain}`}>
                <Box className={`${styles.table_top} ${styles.table_top_inners}`}>{filterRow}</Box>
                <Box className={`${styles.table_main} ${styles.submitUnreahableTable}`}>{children}</Box>
              </Box>
            {/* </PerfectScrollbar> */}
          </Box>
        </Box>
      </Box>
    </Dialog>
  );
}
